import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import LogoSvg from './assets/logo.svg';
import { HeaderMenu } from './HeaderMenu';

const Wrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--gray-01);
  height: 100%;

  @media screen and (max-width: 480px) {
    padding: 0 16px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1120px;
  height: 80px;
  align-items: center;
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    height: 56px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img.attrs({
  src: `${LogoSvg}`,
})``;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const Header: React.FC = observer(() => {
  return (
    <Wrapper>
      <Container>
        <LogoWrapper>
          <Link to={'/'}>
            <Logo alt="Descomplica IO" />
          </Link>
        </LogoWrapper>
        <HeaderRight>
          <HeaderMenu />
        </HeaderRight>
      </Container>
    </Wrapper>
  );
});
